import BaseService from "../BaseService";
import { Notification } from "../../stores/NotificationStore/types";

class NotificationService extends BaseService {
  async getNotification(id: string): Promise<Notification> {
    return await this.fetch<Notification>(`notification/${id}`);
  }

  async getNotifications(
    page: number,
    size: number
  ): Promise<{
    results: Notification[];
    count: number;
  }> {
    return await this.fetch<{
      results: Notification[];
      count: number;
    }>("notifications", {
      pageIndex: page.toString(),
      pageSize: size.toString(),
    });
  }

  async markAsRead(id: string): Promise<Notification> {
    return await this.put<Notification, unknown>(
      `notifications/markAsRead/${id}`
    );
  }

  registerDevice(device: Device, registrationId: string): Promise<void> {
    return this.post<void, { device: Device; registrationId: string }>(
      "device",
      {
        device,
        registrationId,
      }
    );
  }
}

export default NotificationService;
